<template>

  <v-row class="inner-content">
    <v-col>
      <NotificationsTable />
    </v-col>
  </v-row>

</template>

<script>
export default {
  name: 'NotificationsList',

  components: {
    NotificationsTable: () => import('@/components/tables/NotificationsTable.vue')
  },
}
</script>
